import React from 'react'
import { translate } from 'react-i18next'
import './index.sass'

const MosaicText = ({ t, arrText }) => {
  if (!arrText) return null
  return (
    <div className="mosaic-text">
      {arrText.map(text => (
        <div className="mosaic-text-wrapper" key={text.title}>
          <h4 className="subtitle-1">{t(`serviceDetails.${text.title}`)}</h4>
          <p className="body-light">{t(`serviceDetails.${text.text}`)}</p>
        </div>
      ))}
    </div>
  )
}

export default translate('translations')(MosaicText)
